export default "__VITE_ASSET__jNxcNfXi__"